module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reservedFor":"Tickets reserved for","aboutToExpire":{"title":"Reservation is about to expire","message":"Are you still there?","button":"Extend reservation"},"expired":{"title":"Reservation expired","message":"The reservation for your selected tickets expired.","button":"Select new tickets"}}}')
  delete Component.options._Ctor
}
